<template>
  <div>
    <div class="row mb-2">
      <div class="col-lg-10 col-xs-12 pr-2">
        <div class="block_info_white p-2">
          <div class="row">
            <div class="col-lg-2 col-xs-12 center">
              <div class="mt-1">
                <span>
                  <b>PERÍODO</b>
                </span>
              </div>
            </div>
            <div class="col-lg-5 col-xs-12">
              <Datepicker
                input-class="form-control"
                class="p-0"
                placeholder="Data inicial"
                v-model="initial_date"
                :format="customFormatter"
                :language="ptBR"
              ></Datepicker>
            </div>
            <div class="col-lg-5 col-xs-12">
              <Datepicker
                input-class="form-control"
                class="p-0"
                :format="customFormatter"
                placeholder="Data final"
                v-model="end_date"
                :language="ptBR"
              ></Datepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-lg-2 pl-0">
        <button
          @click="loadCalendar"
          type="button"
          class="btn full btn-degrade right"
        >
          <b>PESQUISAR</b>
        </button>
      </div>
    </div>
    <div v-if="calendars.length === 0">
      <h3 class="center mt-5 color-grey">
        NÃO HÁ NENHUM AGENDAMENTO PARA MOSTRAR
      </h3>
    </div>
    <div v-for="calendar in calendars" :key="calendar.id" class="mb-4">
      <div class="block_info_white p-3">
        <span>{{ calendar.day | moment("ll") }}</span>
      </div>

      <table class="table_jovool mt-3">
        <thead class="headerTable">
          <tr class="center">
            <td>Título</td>
            <td class="center">DESCRIÇÃO</td>
            <td class="center">DATA</td>
            <td class="center">CONVIDADOS</td>
          </tr>
        </thead>
        <tbody class="position-relative">
          <tr
            v-for="event in calendar.events"
            :key="event.id"
            class="center"
            :class="{ 'content-loading': loading }"
          >
            <td>{{ event.title }}</td>
            <td>{{ event.description }}</td>
            <td>
              {{ event.start_date | moment("L") }}
              {{ event.start_date | moment("LT") }} até
              {{ event.end_date | moment("LT") }}
            </td>
            <td>
              <span
                v-for="invited in event.invited_calendars"
                :key="invited.id"
                class="f12 px-2 d-block"
              >
                {{ invited.email }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { ptBR } from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";
export default {
  components: { Datepicker },
  props: ["candidate_email"],
  data: () => ({
    ptBR: ptBR,
    loading: false,
    initial_date: "",
    end_date: "",
    calendars: [],
  }),
  mounted() {
    this.initial_date = this.$moment().format();
    this.end_date = this.$moment().add(30, "days").format();
    this.loadCalendar();
  },
  methods: {
    customFormatter(date) {
      return this.$moment(date).format("DD/MM/YYYY");
    },
    loadCalendar() {
      this.loading = true;
      axios
        .get("/recruiters/calendars", {
          params: {
            initial_date:
              this.$moment(this.initial_date).format("YYYY-MM-DD") + " 00:00",
            end_date:
              this.$moment(this.end_date).format("YYYY-MM-DD") + " 23:59",
            candidate_email: this.candidate_email,
          },
        })
        .then((response) => {
          this.loading = false;
          this.calendars = [];
          response.data.calendars.forEach((calendar) => {
            if (calendar.total_day > 0) {
              calendar.events.forEach((element, index) => {
                if (element.status === 0) calendar.events.splice(index, 1);
              });
              if (calendar.events.length > 0) this.calendars.push(calendar);
            }
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>
